import intl from "react-intl-universal";

import {UndoableAction} from "../../common/UndoableAction";
import {WorkspaceModelType} from "@stores/WorkspaceStore";
import {updateItemChildIdsAdd, updateItemChildIdsRemove} from "../updateItem";
import {undoableFunctionCall} from "../../common/undoableFunctionCall";
import {logErrorToSentry} from "../../../utils/errors/logErrorToSentry";
import {CrudServices} from "../../../platform/services/types/ServiceDependencies";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";


export class UpdateItemChildIdsRemoveUndoable implements UndoableAction {
    mstItemId: string;
    childId: string;
    services: CrudServices;
    dsManager: DataSourceManager;
    workspace: WorkspaceModelType;
    index?: number;

    constructor(services: CrudServices, dsManager: DataSourceManager, mstItemId: string, childId: string, workspace: WorkspaceModelType, index?: number) {
        this.services = services;
        this.dsManager = dsManager;
        this.mstItemId = mstItemId;
        this.childId = childId;
        this.workspace = workspace;
        this.index = index;
    }

    execute(): Promise<any> {
        this.index = this.workspace.items.get(this.mstItemId)!.childIds.indexOf(this.childId);
        return updateItemChildIdsRemove(this.services, this.dsManager, this.mstItemId, this.childId, this.workspace);
    }

    undo(): Promise<any> {
        return updateItemChildIdsAdd(this.services, this.dsManager, this.workspace.items.get(this.mstItemId)!, this.childId, this.workspace, this.index);
    }
}

export function updateItemChildIdsRemoveUndoable(
    services: CrudServices,
    dsManager: DataSourceManager,
    mstItemId: string,
    childId: string,
    workspace: WorkspaceModelType,
    index?: number
) {
    const undoableAction = new UpdateItemChildIdsRemoveUndoable(services, dsManager, mstItemId, childId, workspace, index);
    return undoableFunctionCall(undoableAction, intl.get('snackbar.item_update.child_ids_add').d('Page removed from cluster')).catch(logErrorToSentry);
}
